import { render, staticRenderFns } from "./code_purchase_out.vue?vue&type=template&id=589d66f2&scoped=true"
import script from "./code_purchase_out.vue?vue&type=script&lang=js"
export * from "./code_purchase_out.vue?vue&type=script&lang=js"
import style0 from "./code_purchase_out.vue?vue&type=style&index=0&id=589d66f2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589d66f2",
  null
  
)

export default component.exports